import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "h-screen flex justify-center items-center" }
const _hoisted_2 = { style: {"margin-top":"-80px"} }
const _hoisted_3 = {
  class: "card text-primary",
  style: {"min-width":"300px"}
}
const _hoisted_4 = /*#__PURE__*/_createVNode("p", { class: "font-thin text-secondary text-3xl text-center mb-4" }, [
  /*#__PURE__*/_createTextVNode("Sistema de Control "),
  /*#__PURE__*/_createVNode("br"),
  /*#__PURE__*/_createTextVNode(" Pehuén Ltda.")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_login_form = _resolveComponent("login-form")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", null, [
        _createVNode("img", {
          src: require('@/assets/LOGO.jpg'),
          style: {"height":"150px","width":"auto","margin":"0 auto 30px"}
        }, null, 8, ["src"])
      ]),
      _createVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode(_component_login_form, { onLoginFn: _ctx.onLoginDone }, null, 8, ["onLoginFn"])
      ])
    ])
  ]))
}